var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "house-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.739,
    height: 31.345,
    viewBox: "0 0 35.739 31.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1.526,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1213b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6192e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7313",
    "data-name": "Trazado 7313",
    d: "M30.889,44.489l-6.82-6.82-6.2-6.2-6.2,6.2L4.847,44.493,0,49.338l2.791,2.791,4.846-4.846L14.46,40.46l3.409-3.409,3.409,3.409L28.1,47.28l4.85,4.849,2.791-2.791Z",
    transform: "translate(0 -31.469)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7314",
    "data-name": "Trazado 7314",
    d: "M85.719,171.951v10.481h23.772V171.948L97.606,160.063Z",
    transform: "translate(-79.736 -151.087)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7344",
    "data-name": "Trazado 7344",
    d: "M-2079.533,12731.828v-1.395a13,13,0,0,1-2.929-.443,1.9,1.9,0,0,1-1.093-1.426,9.739,9.739,0,0,1,.507-3.183,4.742,4.742,0,0,1,2.217-2.295,3.406,3.406,0,0,1,2.2-.111s.427.4.427.586v5.417h1.843v-7.428h-4.345a6.871,6.871,0,0,0-3.642,1.425,4.393,4.393,0,0,0-1.584,2.406,22.312,22.312,0,0,0-.712,3.073,5.7,5.7,0,0,0,.127,2.295,1.594,1.594,0,0,0,1.3,1.078Z",
    transform: "translate(2095.028 -12702.895)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7345",
    "data-name": "Trazado 7345",
    d: "M-2084.521,12731.828v-1.395a13,13,0,0,0,2.929-.443,1.9,1.9,0,0,0,1.093-1.426,9.727,9.727,0,0,0-.507-3.183,4.741,4.741,0,0,0-2.217-2.295,3.405,3.405,0,0,0-2.2-.111s-.427.4-.427.586v5.417h-1.843v-7.428h4.344a6.87,6.87,0,0,1,3.642,1.425,4.393,4.393,0,0,1,1.584,2.406,22.329,22.329,0,0,1,.713,3.073,5.7,5.7,0,0,1-.127,2.295,1.594,1.594,0,0,1-1.3,1.078Z",
    transform: "translate(2104.765 -12702.895)",
    fill: "url(#linear-gradient-3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.9efcff9c91203b789942e597a72a7ebf.svg";
export { ForwardRef as ReactComponent };